import { render, staticRenderFns } from "./HelpSelectChangeHeader.vue?vue&type=template&id=988795e2&scoped=true&"
import script from "./HelpSelectChangeHeader.vue?vue&type=script&lang=js&"
export * from "./HelpSelectChangeHeader.vue?vue&type=script&lang=js&"
import style0 from "./HelpSelectChangeHeader.vue?vue&type=style&index=0&id=988795e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "988795e2",
  null
  
)

export default component.exports